/* eslint-disable import/prefer-default-export */

import type { EventName } from 'modules/tracking/GA4/types/EventName';
import type { AdvisorToolboxItemWithId } from './types';

export function trackingEventNameMapper(type: AdvisorToolboxItemWithId['type']): EventName | undefined {
    switch (type) {
        case 'Booking':
            return 'booking_selected';
        case 'Chat':
            return 'chat_selected';
        case 'Questionnaire':
            return 'questionnaire_selected';
        default:
            return undefined;
    }
}
